import { render, staticRenderFns } from "./FabricanteCard.vue?vue&type=template&id=4bb97a15&scoped=true"
import script from "./FabricanteCard.vue?vue&type=script&lang=js"
export * from "./FabricanteCard.vue?vue&type=script&lang=js"
import style0 from "./FabricanteCard.vue?vue&type=style&index=0&id=4bb97a15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb97a15",
  null
  
)

export default component.exports